import type {
  DisplayMarketingAdSet,
  DisplayMarketingCampaign,
  MarketingCampaign,
} from "@common/interfaces/KYDMarketing";

/**
 * Applies a persisted {@link MarketingCampaign} snapshot onto the in-memory display model
 * while keeping display-only fields (`event`, `intent`, prior `display_*` ad set fields).
 */
export function mergeDisplayCampaignFromMarketingUpdate(
  prev: DisplayMarketingCampaign,
  incoming: MarketingCampaign
): DisplayMarketingCampaign {
  if (incoming.id && incoming.id !== prev.id) {
    return prev;
  }
  const prevAdsets = prev.adsets ?? [];
  const byId = new Map(prevAdsets.map((a) => [a.id, a]));
  const mergedAdsets: DisplayMarketingAdSet[] = (incoming.adsets ?? []).map(
    (adset) => {
      const p = adset.id ? byId.get(adset.id) : undefined;
      if (!p) {
        return adset as DisplayMarketingAdSet;
      }
      return {
        ...p,
        ...adset,
        ads: adset.ads ?? p.ads,
      };
    }
  );
  return {
    ...prev,
    ...incoming,
    event: prev.event,
    intents: prev.intents,
    adsets: mergedAdsets,
  };
}
